const specialCharsExceptDashAndSlashAndPeriodAndUnderscoreRegex = /[^a-zA-Z0-9_.\-/]/g;

const toLowerCase = (input: string): string => input.toLowerCase();

export const removeInvalidPathSpecialCharacters = (input: string): string => {
  return input.replace(specialCharsExceptDashAndSlashAndPeriodAndUnderscoreRegex, '');
};

const removeAdjacentDuplicateCharacters = (value: string, char: string): string => {
  return value.replace(new RegExp(`\\${char}\\${char}+`, 'g'), char);
};

export const removeInvalidPathAdjacentCharacters = (input: string): string => {
  const withoutAdjacentDashes = removeAdjacentDuplicateCharacters(input, '-');
  const withoutAdjacentDashesAndSlashes = removeAdjacentDuplicateCharacters(
    withoutAdjacentDashes,
    '/',
  );

  return withoutAdjacentDashesAndSlashes;
};

const cleanPathname = (pathname: string): string => {
  return [
    toLowerCase,
    removeInvalidPathSpecialCharacters,
    removeInvalidPathAdjacentCharacters,
  ].reduce((acc, fn) => fn(acc), pathname);
};

export const getEntryRedirectUrl = (url: URL): URL | null => {
  const cleanedPathname = cleanPathname(url.pathname);
  if (cleanedPathname === url.pathname) return null;

  const redirectUrl = new URL(url);
  redirectUrl.pathname = cleanedPathname;

  return redirectUrl;
};
